import "scss/index.scss";
import "lightgallery";


var $ = require("jquery"); // jQuery
//var fastclick = require("fastclick");
var foundation = require("foundation-sites");
var slick = require("stage/js/stage.js");
var readmore = require("events/js/events.js");
var gallery = require("gallery/js/gallery.js");

import { plugin_registry } from 'nk-plugin-registry';

// import your plugins here.
import "custom_form/js/custom_form.js";


plugin_registry.init();
